import React from "react";
import {
  Hero,
  Footer,
  FeatureSection,
  DiscoverSection
} from "../../components";

const Home = () => {
  return (
    <>
      <Hero />
      <FeatureSection />
      <DiscoverSection />
      <Footer />
    </>
  );
};

export default Home;
